/**
 * Veeroute.Delivery
 * Veeroute Delivery API
 *
 * The version of the OpenAPI document: 3.15.183137
 * Contact: support@veeroute.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Objects metrics.
 */
export interface ObjectsMetricsDelivery { 
    /**
     * List of object\'s keys.
     */
    keys?: Set<string>;
    /**
     * The total number of objects.
     */
    count?: number;
}

